import React from "react";
import { FaArrowRight } from "react-icons/fa";
import img2 from "../../assets/aboutus-mainimage.png";
import "./about.css";
import Aboutwhychoose from "./Aboutwhychoose";
import OurClient from "../ourclients/Ourclient";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Aboutus() {

     useEffect(() => {
      AOS.init({
        duration: 1000, // animation duration (1 second)
        once: true,     // animation happens only once
      });
    }, []);
  return (
    <>
      <section className="about-section">

        {/* Breadcrumb */}
        <div className="about-header" data-aos="fade-down">
          <span className="about-breadcrumb">
            <a style={{ color: "#3a3a5e" }} href="/home">Home</a> <FaArrowRight /> <a href="/aboutus">About Us</a>
          </span>

          <h1 className="about-heading">About Us</h1>
          <p className="about-description">
            We create websites, boost online visibility, and drive digital growth for your business.
          </p>
        </div>

        <div className="container mt-5">

          {/* Main content */}
          <div className="about-content">
            {/* Left side - image */}
            <div className="header-image" data-aos="fade-right">
              <img src={img2} alt="Business Growth" />
            </div>

            {/* Right side - text */}
            <div className="header-text" data-aos="fade-left">
              <h3>About us </h3>
              <h2>Transforming ideas into impactful online experiences</h2>
              <p>
                Founded in 2014, <strong>REDITE</strong> has grown from a dynamic startup into a comprehensive digital solutions
                provider. With expertise in software development, web design, SEO services, social media marketing,
                Instagram marketing, and content creation, we help clients elevate their digital presence.
              </p>


            </div>
            <div className="header-text-para" data-aos="fade-down">
              <p>We specialize in crafting digital experiences that drive business growth and engagement. Our team of experts is dedicated to understanding each client’s unique vision and transforming it into impactful, scalable solutions.</p>

              <p>At REDITE, we believe in a client-centered approach, where innovation meets strategy to ensure our solutions are as effective as they are creative. Whether you’re looking to boost your online presence, streamline operations, or engage audiences with compelling content, REDITE is here to make your digital transformation a seamless journey. Join us in shaping
                the future of digital innovation and excellence.</p>
            </div>
          </div>
        </div>
      </section>

      <Aboutwhychoose />

      <OurClient />
    </>
  );
}

export default Aboutus;
